import React from 'react';
import PropTypes from 'prop-types';
import Event from './Event/Event';
import Product from './Product/Product';
import Submit from './Submit/Submit';
import Success from './Success/Success';

const checkImage = require("./imgs/Check.png");
const calederPlusImage = require("./imgs/CalendarPlus.png");
const telegramLogoImage = require("./imgs/TelegramLogo.png");
const cookieImage = require("./imgs/Cookie.png");

const Steps = ({
  currentStep,
  formData,
  onFormDataChange,
  onNext,
  onBack,
  onSubmit
}) => {
  const steps = [
    { id: 1, title: 'Event', icon: calederPlusImage },
    { id: 2, title: 'Product', icon: cookieImage },
    { id: 3, title: 'Submit', icon: telegramLogoImage },
  ];

  const getStepClasses = (stepId) => {
    if (stepId === currentStep) {
      return 'bg-pink-500 border-pink-500 text-white bg-[#EA3E82]';
    }
    if (stepId < currentStep) {
      return 'bg-[#461D58] border-[#5A3770] text-white';
    }
    return 'border-[#5A3770] bg-[#381447] text-gray-400';
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Event
            formData={formData}
            onFormDataChange={onFormDataChange}
            onNext={onNext}
            onBack={onBack}
          />
        );
      case 2:
        return (
          <Product
            formData={formData}
            onFormDataChange={onFormDataChange}
            onNext={onNext}
            onBack={onBack}
          />
        );
      case 3:
        return (
          <Submit
            formData={formData}
            onFormDataChange={onFormDataChange}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        );
      case 4:
        return <Success />;
      default:
        return null;
    }
  };

  return (
    <div className="flex-1 flex flex-col md:px-10">
      {/* Page Title and Subtitle */}
      <div className="mb-4">
        <h1 className="font-congenialBlack text-2xl md:text-3xl xl:text-[44px] text-white mb-2 leading-tight lg:leading-[46px]">
          Custom Order
        </h1>
        <p className="font-medium text-sm text-[#B4A5BB] leading-4 font-montserratMedium">
          Thank you for reaching out! We would be happy to help make your event a bit sweeter.
          <br />
          <br />
          Pricing is slightly different by location. To provide you with the most accurate pricing, please complete the information below regarding your event and request.
        </p>
      </div>

      {/* Step Indicator */}
      <div className="flex flex-row justify-between mb-4 relative overflow-hidden">
        {steps.map((step, index) => (
          <div key={step.id} className="flex flex-col items-center px-3 py-0 relative">
            <div
              className={`w-8 h-8 md:w-10 md:h-10 lg:w-14 lg:h-14 rounded-full flex items-center justify-center mb-2 md:mb-3 relative z-10 border transition-all duration-300 ${getStepClasses(step.id)}
              `}
            >
              <span className="text-xl md:text-2xl h-[30px] w-[30px] md:h-[2rem] md:w-[2rem] flex items-center justify-center">
                <img
                  src={step.id < currentStep ? checkImage : step.icon}
                  alt={step.title}
                  className='h-6 w-6 md:h-[2rem] md:w-[2rem]'
                />
              </span>
            </div>
            <span
              className={`text-[#B4A5BB] text-sm leading-4 font-medium font-montserratMedium text-center transition-colors duration-300
              `}
            >
              <span className='text-white'>
                Step
                {' '}
                {step.id}
              :
              </span>
              {' '}
              {step.title}
            </span>
            {index < 2 && (
              <div className={`absolute top-[16px] md:top-[20px] laptop:top-[28px] left-[70px] ipad:left-[66px] laptop:left-[70px] w-[calc(50vw-82px)] sm:w-[calc(46vw-85px)] ipad:w-[calc(25vw-70px)] laptop:w-[calc(22vw-40px)] h-0.5 border-b-2 border-[#5A3770] ${step.id < currentStep ? 'border-solid' : 'border-dashed'}`}>&nbsp;</div>
            )}
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div>
        {renderCurrentStep()}
      </div>
    </div>
  );
};

Steps.propTypes = {
  currentStep: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
  formData: PropTypes.shape({}).isRequired,
  onFormDataChange: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
export default Steps;
